// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as AdjustFareForm from "./AdjustFareForm.bs.js";
import * as AdjustFareTypesCTA from "./AdjustFareTypesCTA.bs.js";

function AdjustFareFormRoot(Props) {
  var currency_symbol = Props.currency_symbol;
  var new_fare_details = Props.new_fare_details;
  var state = Props.state;
  var dispatch = Props.dispatch;
  React.useEffect((function () {
          if (new_fare_details.data.has_fixed_strategy) {
            
          } else {
            Curry._1(dispatch, {
                  TAG: /* UpdateFormDurationSelector */0,
                  form_duration_selector: /* DateTime */1
                });
          }
          
        }), [new_fare_details.data.has_fixed_strategy]);
  return React.createElement("div", {
              className: "c-adjust-fare-form-container"
            }, React.createElement("div", {
                  className: "c-adjust-fare-form"
                }, React.createElement("p", {
                      className: "adjust-fare-header"
                    }, "Adjust Fare"), React.createElement("div", {
                      className: "forms"
                    }, React.createElement(AdjustFareTypesCTA.make, {
                          new_fare_details: new_fare_details,
                          dispatch: dispatch
                        }), React.createElement(AdjustFareForm.make, {
                          currency_symbol: currency_symbol,
                          new_fare_details: new_fare_details,
                          state: state,
                          dispatch: dispatch,
                          key: Belt_Option.getWithDefault(JSON.stringify(new_fare_details), "")
                        }))));
}

var make = AdjustFareFormRoot;

export {
  make ,
  
}
/* react Not a pure module */
